module.exports = __webpack_public_path__ + "img/angers-sco-logo-icon.b176ef8b.png";